import { httpClient } from "./httpClient";

type Feedback = {
  id: number;
  feedbackId: string;
  feedbackType: string;
  details: string;
  status: string;
  dateTimeAdded: string;
  sentBy: string;
  feedbackSubject: string;
  businessUnit: string;
};

type Data = {
    feedbacks: Feedback[];
};

export async function getFeedbacks( 
    dateFrom: Date,
    dateTo: Date,): Promise<any> {
    try {
      const { data } = await httpClient.get(`/api/v1/feedback`,
      {
        params: {
          dateFrom: dateFrom,
          dateTo: dateTo,
        },
      });
      return data.feedbacks;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }